import styled from 'styled-components';

const PlacePerksWrapper = styled.div`
  font-family: 'Nunito';
  font-style: 'normal';
  font-size: 14px;
  @media (max-width: 1200px) {
    font-size: ${(props) => (props.pageVariant === 'pageVariant3' ? '16px' : '12px')};
  }
  @media (max-width: 768px) {
    font-size: 14px;
  }
  color: #1a1a1a;
  padding-bottom: 12px;
  padding-right: ${(props) => {
    switch (props.pageVariant) {
      case 'pageVariant1':
        return '16px';
      case 'pageVariant2':
        return '12px';
      case 'pageVariant3':
        return '0px';
      default:
        return '0px';
    }
  }};
  padding-left: ${(props) => {
    switch (props.pageVariant) {
      case 'pageVariant1':
        return '0px';
      case 'pageVariant2':
        return '12px';
      case 'pageVariant3':
        return '0px';
      default:
        return '0px';
    }
  }};
  padding-top: ${(props) => props.pageVariant === 'pageVariant1' && '12px'};

  .frame {
    display: flex;
    flex-direction: column;
    align-items: center;
    background: ${(props) => (props.pageVariant === 'pageVariant3' ? '#FFFFFF' : '#f3f3f3')};
    border-radius: 12px;
    border: ${(props) =>
      props.pageVariant !== 'pageVariant3' ? '1px solid #c2c2c2' : '1px solid #D8D8D8'};
    justify-content: center;
    width: 'auto';
  }

  .frame-status {
    padding: 8px;
  }

  .frame-level-up {
    padding: 12px;
    padding-top: 20px;
    position: relative;
    margin-top: 25px;
    font-size: ${(props) => props.theme.typography.fontSizes.fs12};
    box-shadow: ${(props) =>
      props.pageVariant === 'pageVariant3' ? '4px 4px 9px rgba(0, 0, 0, 0.08)' : ''};
    ${(props) =>
      props.pageVariant === 'pageVariant3'
        ? `padding-top:38px;font-size: ${props.theme.typography.fontSizes.fs16};padding-bottom:27px;`
        : ''};
    @media (max-width: 768px) {
      ${(props) =>
        props.pageVariant === 'pageVariant3'
          ? `padding-top:26px;font-size: ${props.theme.typography.fontSizes.fs12};padding-bottom:12px;`
          : ''};
    }
  }

  .level-up-content {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }

  .new-perk-level-message {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .text-line-with-icon {
    display: block;
    text-align: center;
    gap: 3px;
    line-height: 18px;
    padding: ${(props) => (props.pageVariant === 'pageVariant1' ? '0px' : '0px 60px')};
    ${(props) => (props.pageVariant !== 'pageVariant3' ? 'width:298px;' : '')};
    @media (max-width: 768px) {
      padding: ${(props) => (props.pageVariant === 'pageVariant1' ? '0px 30px ' : '0px 20px')};
      padding: ${(props) => (props.pageVariant === 'pageVariant3' ? '0px 15px ' : '0px 20px')};
      width: 298px;
    }
  }

  .injected-value {
    font-weight: 800;
    color: #000000;
  }

  .label {
    position: absolute;
    width: 114.93px;
    height: 25px;
    top: -15px;
    text-align: center;
    line-height: 19px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ffffff;
    border: 2px solid #ff8e15;
    border-radius: 20px;
    ${(props) => (props.pageVariant === 'pageVariant3' ? 'width: 161.93px;' : '')};
    @media (max-width: 768px) {
      ${(props) => (props.pageVariant === 'pageVariant3' ? 'width: 116.93px;' : '')};
    }
  }

  .new-perks-content {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-evenly;
    font-weight: 400;
    font-size: 10px;
    line-height: 14px;
    width: auto;
    gap: 10px;
    height: 36px;
    @media (max-width: 1200px) {
      font-size: ${(props) => (props.pageVariant === 'pageVariant3' ? '12px' : '9px')};
    }
    @media (max-width: 943px) {
      font-size: ${(props) => (props.pageVariant === 'pageVariant3' ? '11px' : '6.5px')};
    }
    @media (max-width: 768px) {
      font-size: ${(props) => (props.pageVariant === 'pageVariant3' ? '11px' : '10px')};
    }
    @media (max-width: 385px) {
      font-size: ${(props) => (props.pageVariant === 'pageVariant3' ? '8px' : '9px')};
    }
  }

  .new-perks-column {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: auto;
    height: 36px;
  }
`;

export default PlacePerksWrapper;
